"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = noParamsReducer;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _ramda = require("ramda");

var _asyncHelpers = require("./asyncHelpers");

function noParamsReducer(customReducer, actions) {
  return function (state, action, defaultReducer) {
    var items = (0, _ramda.path)([_asyncHelpers.noParamsKey], state);
    return items && (0, _ramda.contains)(action.type, actions) ? (0, _objectSpread3["default"])({}, state, (0, _defineProperty2["default"])({}, _asyncHelpers.noParamsKey, customReducer(items, action))) : defaultReducer(state, action);
  };
}